import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppSettings } from './settings';
import { ComprobantesModel } from '../models/comprobantes-model';
import * as FileSaver from 'file-saver';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ComprobantesService {
  
  private rutaApi:string = AppSettings.apiEndpoint;
  private path:string = "";
  private produccion:boolean = AppSettings.produccion;
  public response: any;
  private apiUrl = ``;
  private entity = `pdf`;

  constructor(private http: HttpClient) { 
    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;
  }




  async consulComp (
    nroCuenta:String,
    nroCli:String, 
    nroProv:String, 
    fecha_desde:String, 
    fecha_hasta:String, 
    estado:String,
    tipo:string ='') {
    if(nroCuenta==null||nroCuenta==undefined){ nroCuenta=''; }
    if(nroCli==null||nroCli==undefined){ nroCli=''; }
    if(nroProv==null||nroProv==undefined){ nroProv=''; }
    if(fecha_desde==null||fecha_desde==undefined){ fecha_desde=''; }
    if(fecha_hasta==null||fecha_hasta==undefined){ fecha_hasta=''; }
    if(estado==null||estado==undefined||estado=='TOD'){ estado=''; }
    if(!tipo){ tipo=''; }

    if(this.produccion){ this.path = this.rutaApi+'consultar_comp.php';}
    else { this.path = '/api/consulComp'; }

    const params={
      'cliente': nroCuenta,
      'login': 'N',
      'nro_cliente' : nroCli,
      'nro_proveedor': nroProv,
      'fecha_desde': fecha_desde,
      'fecha_hasta': fecha_hasta,
      'estado':estado,
      'tipo': tipo
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
    let response = await this.http.post<ComprobantesModel>(this.path,params,{headers}).toPromise();

    return  response;
   }

 bajarComp (nroCuenta:string,nroCli:string, nroProv:string, comprobante:string, datosArch:string){
    if(nroCuenta==null||nroCuenta==undefined){ nroCuenta=''; }
    if(nroCli==null||nroCli==undefined){ nroCli=''; }
    if(nroProv==null||nroProv==undefined){ nroProv=''; }
    if(comprobante==null||comprobante==undefined){ comprobante=''; }
    if(datosArch==null||datosArch==undefined){ datosArch=''; }
    let token = sessionStorage.getItem('t');

    let pathCompleto = `${this.apiUrl}/bajada?comprobante=${comprobante}&datosArch=${datosArch}&token=${token}`

    window.open(pathCompleto);
   }

   previewFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);

    const newTab = window.open();
    if (newTab) {
        newTab.document.write(`<iframe src="${url}" width="100%" height="100%"></iframe>`);
        newTab.document.title = fileName; 
    } else {
        alert("Por favor, habilita las ventanas emergentes en tu navegador.");
    }
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  randomNumber(){
    return Math.floor(Math.random() * 100000);
  }

  }




